/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AppSecopsApplicationV2 extends models.AppSecopsApplication {
    getFixupPrototypeFunction() { return AppSecopsApplicationV2.fixupPrototype; }

    static newInstance(model: Partial<AppSecopsApplicationV2>): AppSecopsApplicationV2 {
        let obj = Object.assign(new AppSecopsApplicationV2(), model);
        AppSecopsApplicationV2.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AppSecopsApplicationV2>): AppSecopsApplicationV2 {
        if (!model) return null;
        return AppSecopsApplicationV2.newInstance(<AppSecopsApplicationV2> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AppSecopsApplicationV2) {
        if (!obj) return;

        models.AppSecopsApplicationV2.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AppSecopsApplicationV2): boolean {
        if (models.AppSecopsApplication.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, AppSecopsApplicationV2.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (this.bcs_details) {
            models.AppSecopsApplicationV2BCSDetail.fixupPrototype(this.bcs_details);
        }
        if (this.bcs_history) {
            for (let val of this.bcs_history) {
                models.AppSecopsApplicationV2BCSDetail.fixupPrototype(val);
            }
        }
    }

    bcs_details: models.AppSecopsApplicationV2BCSDetail;

    /**
     * Prior BCS submissions
     */
    bcs_history: Array<models.AppSecopsApplicationV2BCSDetail>;

}
